/* eslint-disable no-unused-vars */
import React, { useRef, useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { IntroView } from '../Intro-View/Intro-View';
import { ContactView } from '../Contact-View/Contact-View';
import { ProjectView } from '../Projects-View/Projects-View';
import { FooterView } from '../Footer-View/Footer-View';

import '../../App.scss';
import './Main-View.scss';

export const MainView = () => {
    const introView = useRef(null);
    const projectsView = useRef(null);
    const contactView = useRef(null);
    const footerView = useRef(null);

    const [introVisible, setIntroVisible] = useState(false);
    const [projectsVisible, setProjectsVisible] = useState(false);
    const [contactVisible, setContactVisible] = useState(false);
    const [footerVisible, setFooterVisible] = useState(false);

    const [viewedSections, setViewedSections] = useState({
        intro: false,
        projects: false,
        contact: false,
        footer: false,
    });

    useEffect(() => {
        const observeIntersection = (ref, setVisibleState, componentName) => {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setVisibleState(true);
                        setViewedSections(prevState => ({
                            ...prevState,
                            [componentName]: true,
                        }));
                    }
                });
            }, { threshold: .5 });
            observer.observe(ref.current);
            return () => observer.unobserve(ref.current);
        };

        observeIntersection(introView, setIntroVisible, 'intro');
        observeIntersection(projectsView, setProjectsVisible, 'projects');
        observeIntersection(contactView, setContactVisible, 'contact');
        observeIntersection(footerView, setFooterVisible, 'footer');

    }, []);

    return (
        <Container id="main-container">
            <Row className={`fade-in-section section-block intro ${viewedSections.intro ? 'is-visible' : ''}`} id="intro-view" ref={introView}>
                <div className="section-block-content">
                    <IntroView />
                </div>
            </Row>
            <Row className={`fade-in-section section-block projects ${viewedSections.projects ? 'is-visible' : ''}`} id="projects-view" ref={projectsView}>
                <div className="section-block-content">
                    <ProjectView className="section-block-content" />
                </div>
            </Row>
            <Row className={`fade-in-section section-block contact ${viewedSections.contact ? 'is-visible' : ''}`} id="contact-view" ref={contactView}>
                <div className="section-block-content">
                    <ContactView className="section-block-content" />
                </div>
            </Row>
            <Row className={`fade-in-section section-block footer ${viewedSections.footer ? 'is-visible' : ''}`} id="footer-view" ref={footerView}>
                <div className="section-block-content">
                    <FooterView className="section-block-content" />
                </div>
            </Row>
        </Container>
    );
};
